import { useState } from 'react';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import {EmailField, PasswordField, Submit} from './Fields.js';
import Typography from '@mui/material/Typography';
import { Link, useNavigate, useParams } from "react-router-dom";
import nwsFetch from './customFetch.js';

export function RequestResetPassword(){
	const navigate = useNavigate();
	const [email, setEmail] = useState("");
	const [error, setError] = useState({});
	async function onSubmit(){
		let response = await nwsFetch("/accounts/api/reset_password/", {
			method: "POST",
			body: JSON.stringify({email: email}),
		});
		if(response.ok){
			return navigate("/email_sent");
		}else{
			setError(await response.json());
		}
	}
	return (
		<Container maxWidth="sm">
			<Box component="form">
				<Typography variant="h3" component="h3">
					Reset your password
				</Typography>
				<Typography variant="h6" component="h6">
					Please enter your account email.
				</Typography>
				<EmailField setField={setEmail} error={error}/>	
				<Submit onSubmit={onSubmit} error={error} name="Reset your password"/>
				<Link to="/login">Go back</Link>
			</Box>
		</Container>
	)
}

export function EmailSent(){
	return (
		<Container maxWidth="sm">
			<Typography variant="h3" component="h3">
				Email sent	
			</Typography>
			<Typography>
				We’ve emailed you instructions for setting your password, if an account exists with the email you entered. You should receive them shortly.
			</Typography>
			<Typography>
				If you don’t receive an email, please make sure you’ve entered the address you registered with, and check your spam folder.
			</Typography>
			<Link to="/login" >Go back</Link>
		</Container>
	)
}

export function ResetPasswordNew(){
	const {uid, token} = useParams();
	const navigate = useNavigate();
	const [password1, setPassword1] = useState("");
	const [password2, setPassword2] = useState("");
	const [error, setError] = useState({});
	async function onSubmit(){
		const data = {
			uid: uid,
			token: token,
			password1: password1,
			password2: password2,
		}
		let response = await nwsFetch("/accounts/api/reset_password_new/", {
			method: "POST",
			body: JSON.stringify(data),
		});
		if(response.ok){
			let url = new URL(document.location.href);
			window.history.pushState({}, "", url.origin);
			return navigate("/login");
		}else{
			setError(await response.json());
		}
	}
	return (
		<Container maxWidth="sm">
			<Box component="form">
				<Typography variant="h3" component="h3">
					Enter your new password
				</Typography>
				<PasswordField setField={setPassword1} error={error} id="password1"/>
				<PasswordField setField={setPassword2} error={error} id="password2" name="Confirm password"/>
				<Submit onSubmit={onSubmit} error={error} name="Reset your password"/>
			</Box>
		</Container>
	)
}
